import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';

/** One learning path as the list endpoint returns it. */
export interface LearningPathListItem {
  _id: string;
  title: string;
  description?: string;
  thumbnail_image_url?: string;
  banner_image_url?: string;
  total_courses?: number;
  status?: string;
}

export interface LearningPathListParams {
  skip?: number;
  limit?: number;
  search?: string;
  /** DRAFT | PUBLISHED | ARCHIVED */
  status?: string;
}

export interface LearningPathListResponse {
  items: LearningPathListItem[];
  total: number;
}

/** Reading learning paths for admin screens. */
class LearningPathService {
  async listLearningPaths(params: LearningPathListParams = {}): Promise<LearningPathListResponse> {
    const response = await apiClient.get(API_ENDPOINTS.LEARNING_PATHS.LIST, { params });
    const data = response.data?.data ?? response.data;
    return {
      items: data?.items ?? [],
      total: data?.total ?? 0,
    };
  }
}

export const learningPathService = new LearningPathService();
export default learningPathService;
